import axios from 'axios';
import { API2_HOST } from '../../helpers/urlHelper';
import { getImageUrl } from 'services/frameImage';

const _URL = `${API2_HOST}/despatch`;

const unwrap = payload => {
  if (!payload) return null;
  if (Object.prototype.hasOwnProperty.call(payload, 'data')) return payload.data;
  return payload;
};

const mapFrameDetail = raw => {
  if (!raw) return null;

  const jobNo = raw.jobNo ?? '';
  const winNo = raw.winNo ?? raw.winno;

  return {
    jobNo: jobNo === null || jobNo === undefined ? '' : String(jobNo),
    winNo: winNo === null || winNo === undefined ? '' : String(winNo),
    customerName: raw.customerName ?? '',
    deliveryDate: raw.deliveryDate ?? null,
    qcCheckedAt: raw.qcCheckAt ?? null,
    frameImageUrl: jobNo && winNo ? getImageUrl({ jobNo, winNo }) : ''
  };
};

const getFrameDespatchDetail = async (headerId, frameId, signal) => {
  const res = await axios
    .get(`${_URL}/frame`, {
      params: { headerId, frameId },
      signal,
      withCredentials: false
    })
    .catch(err => {
      if (err.name === 'CanceledError' || err.code === 'ERR_CANCELED') throw err;
      console.error('getFrameDespatchDetail', err);
      return null;
    });

  if (!res || res.status !== 200) return null;

  return mapFrameDetail(unwrap(res.data));
};

export { getFrameDespatchDetail };
